import React, { Component } from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import { translate } from 'react-i18next'
import onClickOutside from 'react-onclickoutside'

// FIXME: remove locations config from Component src
const locations = [
 {
    name: 'Białystok',
    address1: 'ul. Lipowa 30, lokal 201',
    address2: '15-427 Białystok, PL',
    contact1: 'Tel.: +[48] 508 000 811',
    contact2: 'Fax.: +[48] (85) 74 51 127',
    contact3: 'bialystok@workservice.pl',
    link: '/pl/agencja-pracy-bialystok',
    position: { lat: 53.134437, lng: 23.148442}
  }, {
    name: 'Bielsko-Biała',
    address1: 'ul. Dąbrowskiego 6',
    address2: '43-300 Bielsko-Biała, PL',
    contact1: 'Tel.: +[48] (32) 72 15 636',
    contact2: '',
    contact3: 'bielsko@workservice.pl',
    link: '/pl/agencja-pracy-bielsko-biala',
    position: { lat: 49.826184, lng: 19.043340}
  }, {
    name: 'Bydgoszcz',
    address1: 'ul. Śniadeckich 25/1',
    address2: '85-011 Bydgoszcz, PL',
    contact1: 'Tel.: +[48] (52) 34 57 166',
    contact2: 'Fax: +[48] (52) 511 69 00',
    contact3: 'bydgoszcz@workservice.pl',
    link: '/pl/agencja-pracy-bydgoszcz',
    position: { lat: 53.130071, lng: 18.001893}
  }, {
    name: 'Częstochowa',
    address1: 'ul. Focha 53/5',
    address2: '42-200 Częstochowa, PL',
    contact1: 'Tel.: +[48] (34) 36 82 852',
    contact2: 'Fax.: +[48] (34) 36 82 852',
    contact3: 'czestochowa@workservice.pl',
    link: '/pl/agencja-pracy-czestochowa',
    position: { lat: 50.806991, lng: 19.109495}
  }, {
    name: 'Gdańsk',
    address1: 'Al. Grunwaldzka 163',
    address2: '80-266 Gdańsk, PL',
    contact1: 'Tel.: +[48] (58) 34 18 017',
    contact2: 'Fax.: +[48] (58) 33 38 900',
    contact3: 'gdansk@workservice.pl',
    link: '/pl/agencja-pracy-gdansk',
    position: { lat: 54.384945, lng: 18.596620}
  }, {
    name: 'Gliwice',
    address1: 'ul. Jagiellońska 4',
    address2: '44-100 Gliwice, PL',
    contact1: 'Tel.: +[48] (32) 333 80 01',
    contact2: '',
    contact3: 'gliwice@workservice.pl',
    link: '/pl/agencja-pracy-gliwice',
    position: { lat: 50.297295, lng: 18.678007}
  }, {
    name: 'Katowice',
    address1: 'ul. Kopernika 6',
    address2: '40-064 Katowice, PL',
    contact1: 'Tel.: +[48] (32) 60 70 990',
    contact2: 'Fax.: +[48] (32) 60 70 995',
    contact3: 'katowice@workservice.pl',
    link: '/pl/agencja-pracy-katowice',
    position: { lat: 50.254733, lng: 19.016265}
  }, {
    name: 'Kraków',
    address1: 'Aleja Pokoju 33',
    address2: '31-564 Kraków, PL',
    contact1: 'Tel.: +[48] (12) 29 84 000',
    contact2: 'Fax.: +[48] (12) 446 09 00',
    contact3: 'cv.krakow@workservice.pl',
    link: '/pl/agencja-pracy-krakow',
    position: { lat: 50.064710, lng: 19.989418}
  }, {
    name: 'Legnica',
    address1: 'Plac Wolności 4',
    address2: '59-220 Legnica, PL',
    contact1: 'Tel.: + [+ 48] 508 040 044',
    contact2: 'Tel.: + [+ 48] 508 040 040',
    contact3: 'legnica@workservice.pl',
    link: '/pl/agencja-pracy-legnica',
    position: { lat: 51.205899, lng: 16.154966}
  }, {
    name: 'Lublin',
    address1: 'ul. Królewska 3',
    address2: '20-109 Lublin, PL',
    contact1: 'Tel.: +[48] (81) 46 02 992',
    contact2: 'Tel.: +[48] (81) 46 02 990',
    contact3: 'lublin@workservice.pl',
    link: '/pl/agencja-pracy-lublin',
    position: { lat: 51.247134, lng: 22.565777}
  }, {
    name: 'Łódź',
    address1: 'ul. Wólczańska 128/134',
    address2: '90-527 Łódź, PL',
    contact1: 'Tel.: +[48] (42) 67 82 772',
    contact2: 'Fax.: +[48] (42) 67 81 004',
    contact3: 'cv.lodz@workservice.pl',
    link: '/pl/agencja-pracy-lodz',
    position: { lat: 51.757761, lng:  19.454615}
  }, {
    name: 'Mielec',
    address1: 'ul. Wojska Polskiego 3',
    address2: '39-300 Mielec, PL',
    contact1: 'Tel.: +[48] 512 175 429',
    contact2: 'Tel.:+[48] 508 040 125',
    contact3: 'mielec.cv@workservice.pl',
    link: '/pl/agencja-pracy-mielec',
    position: { lat: 50.308307, lng: 21.454619}
  }, {
    name: 'Olsztyn',
    address1: 'ul. Wyszyńskiego 1 (Budynek Cezal) 1 piętro, lokal 105',
    address2: '11-041 Olsztyn, PL',
    contact1: 'Tel.: +[48] 508 000 873',
    contact2: 'Fax.: +[48] 508 040 330',
    contact3: 'Fax.: +[48] (89) 67 94 735',
    contact4: 'olsztyn@workservice.pl',
    link: '/pl/agencja-pracy-olsztyn',
    position: { lat: 53.770162, lng: 20.509551}
  }, {
    name: 'Poznań',
    address1: 'MALTA OFFICE PARK, ul. Baraniaka 88, bud. D',
    address2: '61-131 Poznań',
    contact1: 'Tel.: +[48] +48 61 628 60 60',
    contact2: 'Fax.: +[48] +48 61 853 47 86',
    contact3: 'poznan@workservice.pl',
    link: '/pl/agencja-pracy-poznan',
    position: { lat: 52.401444, lng: 16.963710}
  }, {
    name: 'Radom',
    address1: 'ul. Struga 26/28',
    address2: '26-600 Radom, PL',
    contact1: 'Tel.: +[48] 508 040 122',
    contact2: '',
    contact3: 'radom@workservice.pl',
    link: '/pl/agencja-pracy-radom',
    position: { lat: 51.405697, lng: 21.159862}
  }, {
    name: 'Rzeszów',
    address1: 'ul. PCK 2',
    address2: '35-060 Rzeszów, PL',
    contact1: 'Tel.: +[48] (17) 78 21 102',
    contact2: 'Fax.: +[48] (17) 28 22 900',
    contact3: 'cv.rzeszow@workservice.pl',
    link: '/pl/agencja-pracy-rzeszow',
    position: { lat: 50.033750, lng: 22.003273}
  }, {
    name: 'Siedlce',
    address1: 'ul. 3-go Maja 28, pok. 313',
    address2: '08-110 Siedlce, PL',
    contact1: 'Tel.: +[48] 508 040 148',
    contact2: 'Tel.: +[48] 501 242 211',
    contact3: 'siedlce@workservice.pl',
    link: '/pl/agencja-pracy-siedlce',
    position: { lat: 52.163962, lng: 22.278321}
  }, {
    name: 'Warszawa',
    address1: 'ul. Grzybowska 3, lokal U6',
    address2: '00-132 Warszawa, PL',
    contact1: 'Tel.: +[48] (22) 49 34 789',
    contact2: 'Fax.: +[48] (22) 18 82 900',
    contact3: 'warszawa@workservice.pl',
    link: '/pl/agencja-pracy-warszawa',
    position: { lat: 52.237308, lng: 21.002346}
  }, {
    name: 'Włocławek',
    address1: 'pl. Wolnoćci 3/4, pok. B104',
    address2: '87-800 Włocławek, PL',
    contact1: 'Tel.: +[48] (54) 232 62 95',
    contact2: 'Tel.: +[48] 512 175 458',
    contact3: 'bydgoszcz@workservice.pl',
    link: '/pl/agencja-pracy-wloclawek',
    position: { lat: 52.655769, lng: 19.067896}
  }, {
    name: 'Wrocław',
    address1: 'ul. Wierzbowa 30',
    address2: '50-056 Wrocław, PL',
    contact1: 'Tel.: + [48] (71) 37 10 826',
    contact2: 'Fax: +[48] (71) 37 10 869',
    contact3: 'wroclaw@workservice.pl',
    link: '/pl/agencja-pracy-wroclaw',
    position: { lat: 51.107079, lng: 17.037457 }
  }, {
    name: 'Wronki',
    address1: 'ul. Poznańska 63 A',
    address2: '64-510 Wronki',
    contact1: 'Tel.: +[48] 508 040 927',
    contact2: 'Tel.: +[48] 512 176 417',
    contact3: 'Tel.: +[48] 508 000 889',
    contact4: 'wronki@workservice.pl',
    link: '/pl/agencja-pracy-wronki',
    position: { lat: 52.705535, lng: 16.378901}
  }
]

/*
 * FIXME: MyMapComponent was created without reading manual (deadline :))
 *        can be buggy
 */

const MyMapComponent = withScriptjs(withGoogleMap((props) => {
  return (
  <GoogleMap
    defaultZoom={15}
    center={{ lat: props.position.lat, lng: props.position.lng }}
  >
    <Marker position={{ lat: props.position.lat, lng: props.position.lng }} />
  </GoogleMap>)

  }
))

const SelectLi = ({ children, value, handleChange }) => {
  const handleClick = () => {
    handleChange(value)
  }
  return (
    <li onClick={handleClick}>
      {children}
    </li>
  )
}

class SelectDD extends Component {
  handleClickOutside = e => {
    this.props.handleToggle()
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="selectbox-selected" onClick={this.props.handleToggle}>{this.props.items[this.props.value].name}</div>
        <div className="selectbox-options">
          <ul>
            {this.props.items.map((item, key) => (
              <SelectLi key={key} value={key} handleChange={this.props.handleChange}>{item.name}</SelectLi>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

const SelectDDContainer = onClickOutside(SelectDD)

class VCCustomGoogleMaps extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggle: false,
      locations,
      // currentLocation: locations[0],
      current: 19
    }
    this.apiKey = 'AIzaSyDuCF6PEXuRJCv96M-GGypiFvDRi_gmgO8'
  }
  handleToggle = (e) => {
    this.setState({ toggle: !this.state.toggle })
  }
  handleChange = (key) => {
    this.setState({ current: key /*, currentLocation: this.state.locations[key]*/, toggle: false })
  }
  render() {
    return (
      <div>
          
      <div className='row googlemaps'>
        <div className='col googlemaps-select'>

          <h2>{this.props.t('custom:findDepartament')}</h2>

          {/* <div className={`selectbox${this.state.toggle ? ' active' : ''}`}>
            <div className='selectbox-label'>Wybierz miejscowość z listy ponizej:</div>
            <div className='selectbox-selected' onClick={this.handleToggle}>{this.state.currentLocation.name}</div>
            <div className='selectbox-options'>
              <ul>
                {this.state.locations.map((location, key) => <li key={key} onClick={e => this.handleChange(key)}>{location.name}</li>)}
              </ul>
            </div>
          </div> */}

          <SelectDDContainer className={`selectbox${this.state.toggle ? ' active' : ''}`} items={this.state.locations} value={this.state.current} handleChange={this.handleChange} handleToggle={this.handleToggle} disableOnClickOutside={!this.state.toggle} />
          
          <div className='infobox'>
            <strong>{this.state.locations[this.state.current].name}</strong>
            <p>{this.state.locations[this.state.current].address1}<br />
            {this.state.locations[this.state.current].address2}</p>
            <p>{this.state.locations[this.state.current].contact1}<br />
            {this.state.locations[this.state.current].contact2}<br />
            {this.state.locations[this.state.current].contact3}</p>
            {(this.state.locations[this.state.current].link && (this.props.t('currentLng') == 'PL')) &&  
                <p>          
                    <a className='branch-link' href={this.state.locations[this.state.current].link}>{this.props.t('custom:customGoogleMaps.branchLink')} {this.state.locations[this.state.current].name}</a> 
                </p>      
            }
          </div>

        </div>
        <div className='col googlemaps-map'>
          <MyMapComponent
            isMarkerShown
            position={this.state.locations[this.state.current].position}
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&v=3.exp&libraries=geometry,drawing,places`}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `400px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
          />
        </div>
      </div>
      {(this.props.t('currentLng') == 'PL') &&  
      <div className='row departments-links'>
        <div className='col'>
          <h4>{this.props.t('custom:ourDepartments')}</h4>
            <div className='list-columns'>
                <ul>
                    {this.state.locations.map((location, key) => 
                    <li key={key}>
                        <a href={location.link}>{this.props.t('custom:customGoogleMaps.branchLink')} {location.name}</a>
                    </li>
                    )}
                </ul>
            </div>
        </div>
      </div>
      }
      </div>
    )
  }
}

export default translate()(VCCustomGoogleMaps)


// WEBPACK FOOTER //
// ./src/custom/components/VCCustomGoogleMaps.js